/* globals document, window */

require('public/css/search.scss');

var THE_SCRIPT = function () {
	const $onReady = require('./lib/on-ready');
	const util = require('./plugin/lib/util');

	const search = {
		type: 'search'
	};

	search.getSearchResults = function (changedField, params) {
		var historyUrl = null;
		if(changedField !== 'history') {
			historyUrl = this.buildHistoryUrl(params);
		}

		if (window.__DISABLE_SEARCH_HISTORY_HANDLER) {
			rp_app.location.redirect(historyUrl);
			return;
		}

		rp$(document).trigger('searchResults:request');
		$ajax({
			method: 'GET',
			dataType: 'json',
			data: params,
			url: this.buildFetchUrl(),
			error: (jqxhr, textStatus, error) => {
				if (textStatus === 'timeout') {
					this.tryCount++;
					if (this.tryCount <= this.maxRetry) {
						$ajax(this);
						return;
					}
				}

				rp$(document).trigger('searchResults:error');
			},
			success: (response, status, xhr) => {
				if(status !== 'success') { return; }

				// Handle the single product redirect to product page case
				if (response && response.redirect_url) {
					rp_app.location.redirect(response.redirect_url);
					return;
				} else if (historyUrl !== null) {
					try {
						if(this.type === 'dynamic_seo') {
							window.history.pushState(params, '', historyUrl);
						} else {
							window.history.pushState({}, '', historyUrl);
						}
					}
					catch (e) {/* TODO: For now, ignoring IE9 and below.. revisit when we do full filtering sidebar */}
					historyUrl = null;
				}

				// If analytics are enabled, count this as another page view
				if (rp_app.env.google_analytics_enabled) {
					window.tracking.ec.products = response.tracking_products;  // Set tracking products so they can be used by Enhanced Ecommerce Product Impressions if enabled
					rp_app.track.track_pageview_all_trackers();
				}
				rp$(document).trigger('searchResults:response', response);
			}
		});
	};

	search.buildFetchUrl = function () {
		return (this.type === 'dynamic_seo') ? '/ajax/dynamic-seo-search' : '/ajax/search';
	};

	search.buildHistoryUrl = function (requestParams) {
		var historyUrl = null;
		var base = rp$('base').attr('href');
		if (!base || typeof base === 'string') {
			base = rp_app.location.getBase();
		}
		var baseUrl = base;
		var currentUrlParams = rp_app.query.all();
		if (this.type === 'dynamic_seo') {
			var currentPath = requestParams.page_url;
			var filterParam = this.buildDynamicSeoFilterParam(requestParams);
			historyUrl = util.addTrailingSlash(baseUrl) + currentPath;
			if(filterParam) {
				historyUrl += '/'+ filterParam;
			}
		} else {
			var currentPath = rp_app.location.pathname.replace(/^\//, '');
			var targetParams = rp$.extend(currentUrlParams, requestParams);
			historyUrl = baseUrl +'/'+ currentPath +'?'+ rp$.param(targetParams);
		}

		return historyUrl;
	};

	search.buildDynamicSeoFilterParam = function (requestParams) {
		const paramArr = [];
		if(requestParams.year) {
			paramArr.push(requestParams.year);
		}
		if(requestParams.make) {
			paramArr.push(requestParams.make);
		}
		if(requestParams.model) {
			paramArr.push(requestParams.model);
		}

		return paramArr.join('-');
	};

	search.handleHistoryChange = function(evt) {
		var params;
		var args = rp_app.query.all(rp_app.location.href);

		/* If we don't have arguments from the URL and we're in a dynamic SEO Context,
		 * check to see if we have arguments stored in the state
		.*-----------------------------------------*/
		if(search.type === 'dynamic_seo' && typeof evt.state === 'object') {
			args.make = evt.state.make;
			args.model = evt.state.model;
			args.year = evt.state.year;
			args.page_id = evt.state.page_id;
			args.page_url = evt.state.page_url;

			if(evt.state.redirect_url) {
				rp_app.location.redirect(evt.state.redirect_url);
				return;
			}
		}

		params = {
			page: args.page,
			search_str: decodeURIComponent(args.search_str),
			year: args.year || '',
			make: args.make || '',
			model: args.model || '',
			page_id: args.page_id || '',
		};
		if (!isNaN(parseInt(args.ptid, 10))) {
			params.ptid = decodeURIComponent(args.ptid);
		}

		search.getSearchResults('history', params);
	};

	search.hookPageHistory = function () {
		window.addEventListener('popstate', this.handleHistoryChange);

		/* For Dynamic SEO pages, treat the root page as a static page. Save the URL to be called when we navigate back to it
		.*-----------------------------------------*/
		if(this.type === 'dynamic_seo') {
			try {
				window.history.replaceState({
					redirect_url: rp_app.location.href
				}, '', rp_app.location.href);
			}

			catch (e) {/* TODO: For now, ignoring IE9 and below.. revisit when we do full filtering sidebar */}
		}
	};

	search.handlePageChange = function(pageNum) {
		const args = rp_app.query.all(rp_app.location.href);

		const params = {
			page: pageNum,
			search_str: decodeURIComponent(args.search_str),
			year: args.year || '',
			make: args.make || '',
			model: args.model || '',
		};
		if (!isNaN(parseInt(args.ptid, 10))) {
			params.ptid = decodeURIComponent(args.ptid);
		}
		search.getSearchResults('page', params);
	};

	if (!window.__DISABLE_SEARCH_HISTORY_HANDLER) {
		search.hookPageHistory();

		rp$(document).on('searchResults:pageChange', function handlePageChange(evt, pageNum) {
			evt.preventDefault();
			search.handlePageChange(pageNum);
		});
	}

	$onReady({rp$, window,
		label: 'search',
		fn: function () {
			var moduleSearchType = rp$('.search-listing-module').data('search-type');
			if(moduleSearchType) {
				search.type = moduleSearchType;
			}

			var $filtersModule = rp$('.search-filters-module .refine-search-form');
			if($filtersModule.length > 0)  {
				$filtersModule.on('changeFilters', function handleFilterChange(evt, changedField, filters) {
					search.getSearchResults(changedField, filters);
				});
			}
		},
	});
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
